import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Typography,
    Paper,
    Stack
} from "@mui/material";

import Logo from "../assets/logoheader.png";

export default function AgeGate() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const verified = localStorage.getItem("ageVerified");
        if (!verified) {
            setOpen(true);
            document.body.style.overflow = "hidden"; 
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    const handleYes = () => {
        localStorage.setItem("ageVerified", "true");
        setOpen(false);
        document.body.style.overflow = "auto";
    };

    const handleNo = () => {
        window.location.href = "https://www.google.com";
    };

    if (!open) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                inset: 0,
                zIndex: 9999,
                background:
                    "linear-gradient(135deg, rgba(2,6,23,0.85), rgba(15,23,42,0.85))",
                backdropFilter: "blur(6px)",
                WebkitBackdropFilter: "blur(6px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 2
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    maxWidth: 420,
                    width: "100%",
                    p: 4,
                    borderRadius: 4,
                    textAlign: "center",
                    background: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(20px)",
                    WebkitBackdropFilter: "blur(20px)",
                    border: "1px solid rgba(255,255,255,0.25)",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
                    color: "#fff"
                }}
            >
                {/* LOGO */}
                <Box sx={{ mb: 3 }}>
                    <img
                        src={Logo}
                        alt="Logo"
                        style={{
                            maxWidth: 160,
                            width: "100%",
                            filter: "drop-shadow(0 6px 12px rgba(0,0,0,0.4))"
                        }}
                    />
                </Box>

                <Typography variant="h5" fontWeight={700}>
                    Conteúdo para maiores de 18 anos
                </Typography>

                <Typography sx={{ mt: 2, opacity: 0.9 }}>
                    Este site é destinado exclusivamente para maiores de 18 anos.
                    Você confirma que possui 18 anos ou mais?
                </Typography>

                <Stack spacing={2.2} sx={{ mt: 4 }}>
                    <Button
                        fullWidth
                        size="large"
                        onClick={handleYes}
                        sx={{
                            borderRadius: 3,
                            py: 1.5,
                            fontWeight: 600,
                            background:
                                "linear-gradient(135deg, #2563eb, #1d4ed8)",
                            color: "#fff",
                            boxShadow: "0 10px 25px rgba(37,99,235,0.45)",
                            "&:hover": {
                                background:
                                    "linear-gradient(135deg, #1d4ed8, #1e40af)"
                            }
                        }}
                    >
                        Sim, tenho 18 anos
                    </Button>

                    <Button
                        fullWidth
                        variant="outlined"
                        size="large"
                        onClick={handleNo}
                        sx={{
                            borderRadius: 3,
                            py: 1.5,
                            fontWeight: 600,
                            color: "#fff",
                            borderColor: "rgba(255,255,255,0.6)",
                            "&:hover": {
                                borderColor: "#fff",
                                backgroundColor: "rgba(255,255,255,0.08)"
                            }
                        }}
                    >
                        Não tenho 18 anos
                    </Button>
                </Stack>
            </Paper>
        </Box>
    );
}